import React from 'react';
import { Link } from 'react-router-dom';

import { LazyPicture } from 'src/hooks/useLazyLoad';

import type { CustomCSSProperties } from '../../../types/pbTypes';
import type { ImageType } from '../imageConfigAggregator';

import classes from './Image.module.scss';

type ImageProps = ImageType & {
    figureStyles: CustomCSSProperties;
    pictureStyles: CustomCSSProperties;
};

/**
 * Return the PB Image
 * @param props
 * @constructor
 */
export function Image(props: ImageProps) {
    const imageClassNames = [classes['root'], 'pageBuilderImageGlobal'];

    if (props.cssClasses && props.cssClasses.length > 0) {
        imageClassNames.push(...props.cssClasses);
    }

    return (
        <figure
            data-content-type={props.contentType}
            data-pb-style={props.uniqueID}
            className={imageClassNames.join(' ')}
            style={{
                ...props.figureStyles,
                alignSelf: props.textAlign,
            }}
        >
            {props.linkType && props.link && (
                <Link
                    to={props.link}
                    target={props.openInNewTab ? '_blank' : '_self'}
                    aria-label={props.altText || 'Image Link'}
                    className={classes.link}
                />
            )}
            <LazyPicture
                className={`${classes['imageContainer']} lozad`}
                style={{ ...props.pictureStyles }}
                data-iesrc={props.desktopImage ?? props.mobileImage ?? ''}
                data-alt={props.altText ?? ''}
            >
                <source media="(min-width: 750px)" srcSet={props.desktopImage} />
                <source media="(max-width: 750px)" srcSet={props.mobileImage} />
            </LazyPicture>
            <figcaption>{props.caption}</figcaption>
        </figure>
    );
}
